import { IButtonStyles, ICheckboxStyles, IDialogContentStyles, IStyle } from '@fluentui/react';
import { FontWeights, IH2OTheme, ISearchStyles, Sizes } from '@h2oai/ui-kit';

export interface IMultiSelectStyles {
  root?: IStyle;
  label: IStyle;
  selectButtonContainer?: IStyle;
  optionsContainer?: IStyle;
  contentRoot?: IStyle;
}

export const multiSelectStylesDefault = (): Partial<IMultiSelectStyles> => ({
  root: {
    width: 400,
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    padding: '5px 0',
  },
  contentRoot: {
    width: '100%',
  },
  selectButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '4px',
    marginBottom: '1rem',
  },
  optionsContainer: {
    width: '100%',
    height: 450,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const multiSelectSearchStyles = (): Partial<ISearchStyles> => ({
  root: {
    marginBottom: '0.5rem',
  },
});

export const multiSelectOptionStyles = (theme: IH2OTheme): Partial<ICheckboxStyles> => ({
  root: {
    padding: '8px 4px',
    '&.is-checked': {
      '.ms-Checkbox-checkbox': {
        backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
        borderColor: theme.semanticColors?.buttonPrimaryBackground,
      },
      backgroundColor: theme.palette?.primary100,
    },
    '&.is-checked.has-error': {
      '.ms-Checkbox-checkbox': {
        background: theme.semanticColors?.inputErrorMessageText,
      },
      '.ms-Checkbox-checkmark': {
        color: theme.semanticColors?.checkboxCheckMarkErr,
      },
    },
    '&.is-disabled': {
      pointerEvents: 'none',
      '.ms-Checkbox-checkbox': {
        borderColor: theme.semanticColors?.inputDisabledBorder,
      },
      '.ms-Checkbox-text': {
        color: theme.semanticColors?.textDisabled,
      },
      '.ms-Checkbox-checkmark': {
        color: theme.semanticColors?.textDisabled,
      },
    },
    '&.has-error': {
      '.ms-Checkbox-checkbox': {
        borderColor: theme.semanticColors?.inputErrorBorder,
      },
      '.ms-Checkbox-text': {
        color: theme.semanticColors?.inputErrorMessageText,
      },
      '.ms-Checkbox-checkmark': {
        color: theme.semanticColors?.checkboxCheckMark,
      },
    },
  },
  checkbox: {
    width: 16,
    height: 16,
    borderColor: theme.semanticColors?.inputReadOnlyText,
    marginRight: 8,
    borderRadius: Sizes.borderRadius,
  },
  checkmark: {
    color: theme.semanticColors?.checkboxCheckMark,
  },
  text: {
    color: theme.semanticColors?.inputReadOnlyText,
    lineHeight: 16,
  },
  label: {
    color: theme.semanticColors?.inputReadOnlyText,
  },
});

export const multiselectPrimaryButtonStyles = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    color: theme.semanticColors?.buttonGhostText,
    backgroundColor: theme.semanticColors?.buttonGhostBackground,
    border: `1px solid ${theme.palette?.gray300}`,
    fontWeight: FontWeights.light,
    display: 'block',
    width: 400,
  },
  rootFocused: {
    backgroundColor: theme.semanticColors?.buttonGhostBackgroundFocused,
    border: `1px solid ${theme.palette?.gray500}`,
    color: theme.semanticColors?.buttonGhostTextFocused,
  },
  rootPressed: {
    backgroundColor: theme.semanticColors?.buttonGhostBackgroundFocused,
    border: `1px solid ${theme.palette?.gray500}`,
    color: theme.semanticColors?.buttonGhostTextFocused,
  },
  rootHovered: {
    backgroundColor: theme.semanticColors?.buttonGhostBackgroundHovered,
    border: `1px solid ${theme.palette?.gray400}`,
    color: theme.semanticColors?.buttonGhostTextHovered,
  },
  menuIcon: {
    color: theme.palette?.gray600,
  },
  rootDisabled: {
    color: theme.semanticColors?.buttonGhostTextDisabled,
    backgroundColor: theme.semanticColors?.buttonGhostBackgroundDisabled,
    borderColor: theme.semanticColors?.buttonGhostBorderDisabled,
    pointerEvents: 'none',
  },
  label: {
    fontWeight: FontWeights.fw400,
    color: theme.palette?.gray600,
  },
});

export const dialogContentStyles: Partial<IDialogContentStyles> = {
  content: {
    overflowX: 'hidden',
  },
};
